import React, { useMemo } from 'react';
import { observer } from 'mobx-react';

import { useRailContext } from 'components/pages/SearchPage/components/SearchGridProvider';

import { AssetCardContext } from '../AssetCardContext/AssetCardContext';
import AssetCardResolveRendering from '../AssetCardResolveRendering/AssetCardResolveRendering';
import { useCardDataResolver } from '../hooks';
import { AssetType } from '../typesOfAsset';

interface Props<T = AssetType> {
  listIndex: number;
  asset: T;
  disableHover?: boolean;
  children?: React.ReactNode;
}

/**
 * @deprecated Will be removed after rhino migration.
*/

const AssetCardProvider = observer(({ asset, disableHover = false, listIndex }: Props) => {
  const { store } = useRailContext();
  const resolvedProps = useCardDataResolver(asset, store);

  const contextValue = useMemo(() => {
    return {
      listStore: store,
      asset,
      disableHover,
      listIndex,
      isGrid: false,
      resolvedProps,
    };
  }, [store, asset, disableHover, resolvedProps, listIndex]);

  return (
    <AssetCardContext.Provider value={contextValue}>
      <AssetCardResolveRendering />
    </AssetCardContext.Provider>
  );
});

export { AssetCardProvider };
